import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { DomH1 } from '../../../HeadingSection';
export var SanityNewsH1 = function (props) {
    var children = props.children;
    return (React.createElement(DomH1, { color: ouiStyle.Constants.Colors.accent, paddingTop: ['simple', undefined, undefined, 'simple', undefined, undefined], paddingBottom: ['simple', undefined, undefined, 'none', undefined, undefined] }, children));
};
